import { createFileRoute } from '@tanstack/react-router'
import AllCoursesPage from '#/pages/AllCoursesPage'
import { coursesQueryOptions } from '#/features/courses/hooks/useCourses'
import { categoriesQueryOptions } from '#/features/courses/hooks/useCategories'
import { tagsQueryOptions } from '#/features/courses/hooks/useTags'

export type CoursesSearch = {
  page?: number
  category?: string
  tag?: string
  search?: string
}

export const Route = createFileRoute('/_home/courses/')({
  validateSearch: (search: Record<string, unknown>): CoursesSearch => ({
    page: Number(search?.page) || 1,
    category: (search?.category as string) || undefined,
    tag: (search?.tag as string) || undefined,
    search: (search?.search as string) || undefined,
  }),
  loaderDeps: ({ search }) => search,
  loader: async ({ context: { queryClient }, deps }) => {
    await Promise.all([
      queryClient.ensureQueryData(
        coursesQueryOptions({
          page: deps.page,
          categorySlug: deps.category,
          tags: deps.tag,
          search: deps.search,
          limit: 9,
        }),
      ),
      queryClient.ensureQueryData(coursesQueryOptions({ limit: 5 })),
      queryClient.ensureQueryData(categoriesQueryOptions()),
      queryClient.ensureQueryData(tagsQueryOptions()),
    ])
  },
  head: () => ({
    meta: [
      {
        title: "All Courses | Wa'allamah",
      },
      {
        name: 'description',
        content:
          "Explore comprehensive Quran recitation, Tajweed, Islamic Studies, and Arabic language courses at Wa'allamah.",
      },
    ],
  }),
  component: AllCoursesPage,
})
